import { rgba } from 'polished';
import { DefaultTheme, ThemeProps } from 'styled-components';
import { Color, Theme } from '../../theme';

const colorForLabel = (label: Color) => ({ theme }: ThemeProps<Theme>): string =>
  theme.colors[label];

export type Colors = {
  [T in Color]: ({ theme }: ThemeProps<Theme>) => string;
};

const colors: Colors = {
  core01: colorForLabel('core01'),
  core02: colorForLabel('core02'),
  core03: colorForLabel('core03'),
  core04: colorForLabel('core04'),
  core05: colorForLabel('core05'),
  core06: colorForLabel('core06'),
  neutral01: colorForLabel('neutral01'),
  neutral02: colorForLabel('neutral02'),
  neutral03: colorForLabel('neutral03'),
  neutral04: colorForLabel('neutral04'),
  neutral05: colorForLabel('neutral05'),
  neutral06: colorForLabel('neutral06'),
  neutral07: colorForLabel('neutral07'),
  neutral08: colorForLabel('neutral08'),
  cardBorder: colorForLabel('cardBorder'),
  cardIcon: colorForLabel('cardIcon'),
  navigationHighlight: colorForLabel('navigationHighlight'),
  notificationError: colorForLabel('notificationError'),
  notificationErrorDark: colorForLabel('notificationErrorDark'),
  notificationErrorLight: colorForLabel('notificationErrorLight'),
  notificationWarning: colorForLabel('notificationWarning'),
  notificationWarningLight: colorForLabel('notificationWarningLight'),
  notificationSuccess: colorForLabel('notificationSuccess'),
  notificationSuccessLight: colorForLabel('notificationSuccessLight'),
  notificationInfo: colorForLabel('notificationInfo'),
  notificationInfoLight: colorForLabel('notificationInfoLight'),
  selectorHighlight: colorForLabel('selectorHighlight'),
  selectorHighlightWithTransparency: colorForLabel('selectorHighlightWithTransparency'),
};

export const colorWithOpacity = (
  color: ({ theme }: ThemeProps<Theme>) => string,
  opacity: number
) => (themeProps: ThemeProps<DefaultTheme>): string => rgba(color(themeProps), opacity);

export default colors;
